import React, { useEffect, useMemo } from "react";
import { Button, Form, Input, Typography } from "antd";
import { resetPassword } from "../../services/user.service";
import { useMutation } from "react-query";
import { AlertService } from "../../services/alert.service";
import { useNavigate } from "react-router";
import { useLocation } from "react-router";

export default function Reset() {
  const [formResetPassword] = Form.useForm();

  const navigate = useNavigate();

  const { Title, Text } = Typography;

  function useQuery() {
    const { search } = useLocation();

    return useMemo(() => new URLSearchParams(search), [search]);
  }

  const query = useQuery();

  const { mutate: reset, isLoading: resetLoading } = useMutation(
    resetPassword,
    {
      onSuccess: () => {
        AlertService.sendAlert([
          {
            text: "Senha redefinida com sucesso.",
            nextPage: true,
          },
        ]);

        navigate("/");
      },
    }
  );

  const onFinish = async (values: any) => {
    formResetPassword
      .validateFields()
      .then((values) => reset(values))
      .catch(() =>
        AlertService.sendAlert([
          { text: "Campo(s) com preenchimento inválido", type: "error" },
        ])
      );
  };

  useEffect(() => {
    let token = query.get("token");
    let email = query.get("email");

    if (!token || !email) {
      AlertService.sendAlert([
        {
          text: "Não foi encontrado um token ou e-mail correspondente.",
          type: "error",
        },
      ]);
    }

    formResetPassword.setFieldsValue({
      token,
      email,
    });
  }, []);

  return (
    <>
      <Title level={2}>
        Redefinir senha{" "}
        <Text type="warning" underline strong>
          __
        </Text>
      </Title>

      <Text>
        Insira uma nova senha para sua conta. Certifique-se de atender os
        seguintes critérios:
      </Text>
      <Text>
        - Pelo menos 8 caracteres de comprimento
        <br />- Deve conter pelo menos uma letra maiúscula
        <br />- Deve incluir pelo menos um caractere especial
      </Text>

      <Form
        onFinish={onFinish}
        form={formResetPassword}
        autoComplete="off"
        layout="vertical"
        style={{ marginTop: 20 }}
      >
        <Form.Item name="token" style={{ display: "none" }}>
          <Input id="token" />
        </Form.Item>

        <Form.Item name="email" style={{ display: "none" }}>
          <Input id="email_input" />
        </Form.Item>

        <Form.Item
          name="password"
          label="Nova senha"
          data-html="true"
          rules={[
            { required: true, message: "Campo obrigatório" },
            { min: 8, message: "A senha deve ter no mínimo 8 caracteres" },
            {
              pattern: new RegExp(
                "^(?=.*[a-z])(?=.*[A-Z])(?=.*\\d)(?=.*[-+_!@#$%^&*.,?]).+$"
              ),
              message:
                "A senha inserida não atende aos critérios de segurança mínimos.",
            },
          ]}
        >
          <Input.Password
            type="password"
            size="large"
            maxLength={100}
            style={{ marginTop: 5 }}
          />
        </Form.Item>

        <Form.Item
          name="password_confirmation"
          label="Repita a nova senha"
          data-html="true"
          dependencies={["password"]}
          rules={[
            { required: true, message: "Campo obrigatório" },
            ({ getFieldValue }) => ({
              validator: (_, value) => {
                if (!value || value == getFieldValue("password")) {
                  return Promise.resolve();
                }

                return Promise.reject(
                  new Error(
                    "As passwords não coincidem. Utilize as mesmas passwords nos dois campos."
                  )
                );
              },
            }),
          ]}
        >
          <Input.Password
            type="password"
            size="large"
            maxLength={100}
            style={{ marginTop: 5, marginBottom: 10 }}
          />
        </Form.Item>

        <Form.Item>
          <Button
            type="primary"
            htmlType="submit"
            loading={resetLoading}
            size="large"
            block
          >
            <Text>Redefinir senha</Text>
          </Button>
        </Form.Item>
      </Form>
    </>
  );
}
